import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export default function transformer(type, serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 1;
    serverTableData.orderBy = 'libelle';
  }
  if (type === PARAMETRES_KEYS.modeReglement) {
    if (!!serverTableData.orderBy && serverTableData.orderBy === 'traite') serverTableData.orderBy = 'modeReglement';
  }
  return generalTransformer(serverTableData);
}
